import Image from 'next/legacy/image';
import { useState } from 'react';
import Pagination from '../Pagination/Pagination';
import DrawerButton from '../Button/DrawerButton';
import Link from 'next/link';
import { Company } from 'data/types';

interface InstallerReviewListProps {
  companies: Company[];
  //   rating: number;
  //   imageURL: string;
}

export default function InstallerReviewList({
  companies,
}: //   rating,
//   imageURL,
InstallerReviewListProps) {
  // State to track the current page
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // You can adjust this to your desired number

  // Calculate the start and end indices for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Slice the companies array to display only the items for the current page
  const displayedCompanies = companies.slice(startIndex, endIndex);

  // Function to handle page navigation
  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  return (
    <>
      <div className="md:block hidden">
        <table className="min-w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              <th className="bg-primary-300 "></th>
              <th className="px-2 py-2 text-left bg-primary-300 text-white">
                Installer
              </th>

              <th className=" py-2 text-left bg-primary-300 text-white">
                Rating
              </th>
              <th className="px-4 py-2 text-left bg-primary-300 text-white"></th>
            </tr>
          </thead>
          <tbody>
            {displayedCompanies.map((company) => (
              <tr key={company.slug} className="m-0 p-0">
                {/* Company Logo */}
                <td className="px-12 h-16 relative">
                  <div className="absolute inset-0 flex items-center justify-center">
                    {company.imageURL && (
                      <Image
                        src={company.imageURL}
                        alt={`${company.name} Logo`}
                        width={70}
                        height={70}
                        objectFit="contain"
                        className="rounded-sm pt-2"
                      />
                    )}
                  </div>
                </td>

                <td className="px-12 h-16 relative">
                  <div className="absolute inset-0 flex items-center justify-left">
                    <p className="font-medium text-black m-0 text-left">
                      {company.name}
                    </p>
                  </div>
                </td>

                {/* Company Rating */}
                <td className="my-auto">
                  <div className="flex space-x-1">
                    <div className="mr-[1px] my-auto text-gray-900">
                      {company.rating !== undefined ? `${company.rating}` : '-'}
                    </div>
                    {Array.from(
                      { length: Math.round(Number(company.rating)) },
                      (_, i) => (
                        <span key={i} className="text-yellow-400 text-xl">
                          ★
                        </span>
                      )
                    )}
                    {Array.from(
                      { length: 5 - Math.round(Number(company.rating)) },
                      (_, i) => (
                        <span key={i} className="text-gray-300 text-xl">
                          ★
                        </span>
                      )
                    )}
                  </div>
                  <Link
                    href={`solar-installer-reviews/${company.slug}`}
                    legacyBehavior
                  >
                    {'Read Reviews (' + company.count + ')'}
                  </Link>
                </td>
                {/* Free Quote Button */}
                <td className="flex items-center">
                  <DrawerButton size="lg">Free quote</DrawerButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(companies.length / itemsPerPage)} // Calculate total pages
          onPageChange={handlePageChange}
        />
      </div>
      <div className="block md:hidden">
        <table className="min-w-full border-collapse border border-gray-300 ">
          <thead>
            <tr>
              <th className="px-2 py-2 text-center border-0 bg-primary-300 text-white">
                Installer
              </th>

              <th className=" py-2 text-center bg-primary-300 border-0 text-white">
                Rating
              </th>
              <th className="  bg-primary-300 text-white border-0"></th>
            </tr>
          </thead>
          <tbody>
            {displayedCompanies.map((company) => (
              <tr key={company.slug} className="m-0 p-0">
                {/* Company Logo */}
                <td className="px-12 h-16 relative">
                  <div className="absolute inset-0 flex flex-col items-center justify-center">
                    {company.imageURL && (
                      <Image
                        src={company.imageURL}
                        alt={`${company.name} Logo`}
                        className="rounded-sm"
                        width={70}
                        height={70}
                      />
                    )}
                    <p className="font-medium text-black m-0 text-center">
                      {company.name}
                    </p>
                  </div>
                </td>

                {/* Company Rating */}
                <td className="my-auto">
                  <div className="flex flex-col space-x-1">
                    <div className="mr-[1px] my-auto text-gray-900">
                      <p className="text-center p-0 m-0">
                        {company.rating !== undefined
                          ? `${company.rating}`
                          : '-'}
                      </p>
                    </div>
                    <div>
                      <p className="p-0 m-0 text-center">
                        {Array.from(
                          { length: Math.round(Number(company.rating)) },
                          (_, i) => (
                            <span
                              key={i}
                              className="text-yellow-400 text-xs mx-auto"
                            >
                              ★
                            </span>
                          )
                        )}
                        {Array.from(
                          { length: 5 - Math.round(Number(company.rating)) },
                          (_, i) => (
                            <span
                              key={i}
                              className="text-gray-300 text-xs text-center"
                            >
                              ★
                            </span>
                          )
                        )}
                      </p>
                    </div>
                  </div>
                  <p className="text-center p-0 m-0">
                    <Link
                      href={`solar-installer-reviews/${company.slug}`}
                      legacyBehavior
                    >
                      {'Read Reviews (' + company.count + ')'}
                    </Link>
                  </p>
                </td>
                {/* Free Quote Button */}
                <td className=" flex items-center mx-auto justify-center">
                  <DrawerButton size="sm" className="mr-2 justify-center">
                    Free quote
                  </DrawerButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(companies.length / itemsPerPage)} // Calculate total pages
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
}
